import React, { useCallback, useState } from 'react'
import { Card } from 'reactstrap'
import { TitlePage } from 'components/atoms'
import MerchantInboundRejectReturnTable from 'domains/merchant-inbound-reject-return/organisms/table'
import MerchantInboundRejectReturnApiV2 from 'api/v2/admins/merchant-inbound-reject-returns-api-v2'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const MerchantInboundRejectReturnListPage = ({ pageUtils }) => {

  const [ rejectReturns, setRejectReturns ] = useState([])
  const [ pagination, setPagination ]       = useState({})
  const [ isLoading, setIsLoading ]         = useState(false)
  const history                             = useHistory()

  const handleFetchInboundRejectReturn = async (tableState) => {
    setIsLoading(true)
    await MerchantInboundRejectReturnApiV2.get({ tableState: tableState })
      .then((response) => {
        setRejectReturns(response.data.inbound_reject_returns)
        setPagination(response.data.meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => setIsLoading(false))
  }

  // Goes to ReceiveDetail Page when clicking on the row button
  const handleSelectRow = useCallback((datum) => {
    const id = datum.id
    history.push({
      pathname: `${id}/detail`
    })
  }, [ history ])

  const hiddenColumns = [
    'id',
    'admin_id',
    'tracking_no',
    'street_address',
    'kecamatan',
    'kelurahan',
    'kota',
    'provinsi',
    'kode_pos',
    'courier',
    'updated_at'
  ]

  return (
    <>
      <TitlePage mainTitle='Merchant Outbound Reject Returns' subTitle='' />

      <Card>

        <MerchantInboundRejectReturnTable
          data={ rejectReturns }
          pagination={ pagination }
          onFetchData={ handleFetchInboundRejectReturn }
          hiddenColumns={ hiddenColumns }
          isLoading={ isLoading }
          rowButtonProps={{
            buttonText    : 'Detail',
            buttonColour  : 'primary',
            onButtonClick : handleSelectRow
          }}
        />

      </Card>
    </>
  )
}

MerchantInboundRejectReturnListPage.propTypes    = propTypes
MerchantInboundRejectReturnListPage.defaultProps = defaultProps

export default MerchantInboundRejectReturnListPage
